/**
 * GET for the public report's data. Sends credentials: since #1042 what the
 * API returns depends on the viewer (a workshop or Sitra session, or the
 * report session a correct report PIN opens), and in local dev the API is
 * another origin. A failed request reads as null, as the report expects.
 */
export async function fetchJson(url) {
  const res = await fetch(url, { credentials: 'include' });
  if (!res.ok) return null;
  return res.json();
}
